import './image_input_component.scss'
import { Controller } from 'stimulus'
import Dropzone from 'dropzone'
import DirectUploadHelper from 'helpers/direct_upload_helper'
import { getMetaValue, removeElement } from 'helpers'

export default class extends Controller {
  static targets = ['input', 'dropzone', 'checkbox']
  static values = {
    maxFiles: Number,
    imageUrl: String,
    imageFilename: String,
    imageByteSize: Number
  }

  connect = (): void => {
    this.createDropZone()
    this.bindEvents()
    this.displayExistingImage()
  }

  createDropZone = (): void => {
    this.dropZone = new Dropzone(this.dropzoneTarget, {
      url: this.url,
      headers: this.headers,
      maxFiles: this.maxFilesValue,
      thumbnailWidth: 320,
      thumbnailHeight: 320,
      addRemoveLinks: true,
      acceptedFiles: 'image/jpeg,image/png',
      autoQueue: false
    })
  }

  bindEvents = (): void => {
    this.dropZone.on('addedfile', file => {
      if (file.cropped === true) { return }

      setTimeout(() => {
        this.fileName = file.name
        if (this.cropperController != null) {
          this.dropZone.removeFile(file)
          if (file.accepted === true) {
            this.cropperController.open(file, this.croppedSuccessful.bind(this), this.croppedCancelled.bind(this))
          }
        } else {
          this.createDirectUploadHelper(this, file).start()
        }
      }, 500)
    })

    this.dropZone.on('success', (file, response) => {
      this.checkboxTarget.checked = false
    })

    this.dropZone.on('removedfile', file => {
      this.checkboxTarget.checked = true
      if (file.controller != null) {
        removeElement(file.controller.hiddenInput)
      }
    })

    this.dropZone.on('canceled', file => {
      file.controller?.xhr?.abort()
    })
  }

  croppedSuccessful = (file): void => {
    file.cropped = true
    file.name = this.fileName
    this.dropZone.addFile(file)
    this.createDirectUploadHelper(this, file).start()
  }

  croppedCancelled = (): void => {
  }

  createDirectUploadHelper = (source, file): DirectUploadHelper => {
    return new DirectUploadHelper(source, file)
  }

  displayExistingImage = (): void => {
    const imageUrl = this.imageUrlValue
    if (imageUrl !== null && imageUrl !== '' && imageUrl !== undefined) {
      const mockFile = { name: this.imageFilenameValue, size: this.imageByteSizeValue, accepted: true, kind: 'image', cropped: true }

      const callback = null
      const crossOrigin = null
      const resizeThumbnail = false

      this.dropZone.displayExistingFile(mockFile, imageUrl, callback, crossOrigin, resizeThumbnail)
      this.dropZone.files.push(mockFile)
    }
  }

  get headers (): object {
    return { 'X-CSRF-Token': getMetaValue('csrf-token') }
  }

  get url (): string {
    return this.inputTarget.getAttribute('data-direct-upload-url')
  }

  get cropperController (): object {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === 'cropper'
    })
  }

  disconnect = (): void => {
    Dropzone.forElement(this.dropzoneTarget).destroy()
  }
}
